module.exports = __webpack_public_path__ + "static/media/r27.84664d08.jpg";